module.exports = __webpack_public_path__ + "img/logo_u1992-22.8c10fe57.svg";